import { gql } from "graphql-request";

export const ADMIN_HANDBOOKS = gql`
  query AdminHandbooks($input: AdminHandbooksInputDto!) {
    adminHandbooks(input: $input) {
      items {
        _id
        slug
        title
        subtitle
        thumbnailUrl
        parentIds
        relatedIds
        aboutSlot
        excerpt
        tags
        status
        publishedAt
        createdAt
        updatedAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_HANDBOOK_BY_ID = gql`
  query AdminHandbookById($handbookId: String!) {
    adminHandbookById(handbookId: $handbookId) {
      _id
      slug
      title
      subtitle
      thumbnailUrl
      parentIds
      relatedIds
      aboutSlot
      footnotes {
        id
        content
      }
      content
      excerpt
      tags
      status
      publishedAt
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
